import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const PhysicsShatterAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number
) => {
  const segments = 60; 
  const t = timeSeconds; // Physics time
  for (let i = 0; i < segments; i++) {
    const startAng = (i / segments) * Math.PI * 2;
    const endAng = ((i + 1) / segments) * Math.PI * 2;
    const midAng = (startAng + endAng) / 2;
    const rStart = getRadiusAtAngle(startAng, e, e.maxRadius);
    const rEnd = getRadiusAtAngle(endAng, e, e.maxRadius);
    const rMid = getRadiusAtAngle(midAng, e, e.maxRadius);
    const xStart = Math.cos(startAng) * rStart;
    const yStart = Math.sin(startAng) * rStart;
    const xEnd = Math.cos(endAng) * rEnd;
    const yEnd = Math.sin(endAng) * rEnd;
    const xMid = Math.cos(midAng) * rMid;
    const yMid = Math.sin(midAng) * rMid;
    const force = config.shatterForce ?? 150;
    const gravity = config.shatterGravity ?? 1000;
    const vx = Math.cos(midAng) * force * t;
    const vy = Math.sin(midAng) * force * t + gravity * t * t; 
    ctx.save();
    const centerX = clampX(e.pos.x + xMid + vx);
    const centerY = clampY(e.pos.y + yMid + vy);
    ctx.translate(centerX, centerY);
    const thickness = 15 * (1 - progress * 0.3);
    const safeScale = (r: number) => r > 0.001 ? (r - thickness) / r : 0;
    const rScaleStart = safeScale(rStart);
    const rScaleEnd = safeScale(rEnd);
    const rScaleMid = safeScale(rMid);
    const xStartIn = xStart * rScaleStart;
    const yStartIn = yStart * rScaleStart;
    const xEndIn = xEnd * rScaleEnd;
    const yEndIn = yEnd * rScaleEnd;
    const xMidIn = xMid * rScaleMid;
    ctx.beginPath();
    ctx.moveTo(xStart - xMid, yStart - yMid);
    ctx.lineTo(0, 0);
    ctx.lineTo(xEnd - xMid, yEnd - yMid);
    ctx.lineTo(xEndIn - xMid, yEndIn - yMid);
    ctx.lineTo(xMidIn - xMid, yMid * rScaleMid - yMid); 
    ctx.lineTo(xStartIn - xMid, yStartIn - yMid);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }
};

registerBlastAnimation('PHYSICS_SHATTER', PhysicsShatterAnimation);
